<template>
  <div>
    <v-card elevation="6" class="base-card-container pa-0 mt-4">
      <v-card-title class="card-title-style"> Agregar Movimiento </v-card-title>
      <v-form ref="form" v-model="validForm" lazy-validation>
        <v-card-text>
          <v-row justify="center" v-if="loaded == false">
            <v-col cols="12" md="7">
              <v-skeleton-loader
                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row justify="center" v-if="loaded == true">
            <v-col cols="12" md="7">
              <div>
                <span class="type-label-style">
                  {{ encabezadoText[0].txtLabel }}
                </span>
                <p class="type-text-style">{{ encabezadoText[1].txtLabel }}</p>
              </div>
              <v-divider class="mt-1"></v-divider>

              <div>
                <span class="type-label-style">Respuesta:</span>
                <p class="type-text-style">{{ respuestaText }}</p>
              </div>
              <v-divider class="mt-1"></v-divider>

              <div class="my-5">
                <span class="type-label-style">Fecha del movimiento:</span>
                <vs-collapse class="title-card-style mb-1 addMovimientoClassList" style="height: 100% !important">
                  <vs-collapse-item not-arrow class="collapsable-container" :open="false">
                    <div slot="header" class="collapsable-header-style" id="datePickerCollapse">
                      <p class="date-card-title-text text-center">
                        {{ selectedDate }}
                      </p>
                    </div>
                    <v-container class="calendar-container-style">
                      <v-date-picker v-model="selectedDate" :min="dateComponentConstraints.fechaMinima"
                        :max="dateComponentConstraints.fechaMaxima" full-width class="mt-0"
                        locale="es-MX"></v-date-picker>
                    </v-container>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
              <v-divider class="mt-1"></v-divider>

              <div>
                <div v-if="documentosTag == true">
                  <span class="type-label-style"> Documentos: </span>
                </div>
                <v-row>
                  <v-col v-for="(item, index) in inputDinamicos" :key="index">
                    <v-checkbox v-if="item.tipoInput == 'checkbox'" v-model="dynamicInputVmodels[index].valor">
                      <template slot="label">
                        <span class="document-chekboxes-style">
                          {{ item.txtlabel }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <div v-if="documentosTag == true && dynamicInputsErrorMessage == true
                ">
                  <span class="error-message-style mb-3">Debe seleccionar al menos una opción</span>
                </div>
              </div>
              <v-row class="mt-4">
                <div v-for="(item, index) in extraDataItems" :key="index" :class="'mt-2 ' + item.size != null
                  ? 'col-12 col-md-' + item.size
                  : ''
                  ">
                  <div id="texFieldType" v-if="item.tipoInput == 'textfield'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-text-field :rules="dynamicRulesGen(item)" :type="extraDataItems[index].textType != undefined
                      ? extraDataItems[index].textType
                      : 'text'
                      " solo v-model="dynamicVModels[index].valor" v-on:blur="
                        extraDataItems[index].textType == 'number'
                          ? null
                          : dynamicVModels[index].valor != ''
                            ? dynamicVModels[index].valor.trim()
                            : null
                        "></v-text-field>
                  </div>
                  <div id="selectType" v-if="item.tipoInput == 'select'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-select solo :rules="dynamicRulesGen(item)" v-model="dynamicVModels[index].valor"
                      :items="dynamicVModels[index].opciones" item-text="descripcion" item-value="valor"
                      @change="subelemento(dynamicVModels[index].valor, index)"></v-select>
                  </div>

                  <div cols="12" md="7" id="mailTextField" v-if="item.tipoInput == 'mailTextfield'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-autocomplete solo chips clearable deletable-chips :rules="dynamicRulesGen(item)"
                      :items="dynamicVModels[index].items" v-model="dynamicVModels[index].valor"
                      :search-input.sync="dynamicVModels[index].searchIteam" no-data-text="Introduzca un correo válido"
                      @change="resetItemsSelector($event, item, index)"
                      @keyup="addMailValider($event, item, index)"></v-autocomplete>
                    <v-chip class="ma-2" close color="#536DFE" dark v-for="(chips, chipIndex) in dynamicVModels[index]
                      .selectedItems" :key="chipIndex" @click:close="deleteFromList(index, chips)">
                      {{ chips }}
                    </v-chip>
                  </div>
                  <div id="selectType" v-if="item.tipoInput == 'selectCorreos'">
                    <div style="height: 22px"></div>
                    <v-select solo :rules="dynamicRulesGen(item)" v-model="dynamicVModels[index].valor"
                      :items="dynamicVModels[index].opciones" item-text="descripcion" item-value="valorZona" @change="
                        newSelectedMails(dynamicVModels[index].valor, index - 1)
                        "></v-select>
                  </div>
                  <div id="areaType" v-if="item.tipoInput == 'textarea'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-textarea v-on:blur="
                      dynamicVModels[index].valor =
                      dynamicVModels[index].valor.trim()
                      " :rules="dynamicRulesGen(item)" v-model="dynamicVModels[index].valor" class="mt-1"
                      outlined></v-textarea>
                  </div>
                  <div id="TODO_other"></div>
                </div>
              </v-row>

              <div class="mt-4">
                <span class="type-label-style">Observaciones:</span>
                <v-textarea v-on:blur="
                  observacionesSelected = observacionesSelected.trim()
                  " v-model="observacionesSelected" class="mt-1" outlined :rules="rulestextarea"></v-textarea>
              </div>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#536DFE" dark v-on:click="saveMovimientoProcess()">Guardar</v-btn>
              <v-btn color="#F5F5F5" v-on:click="clearOptions()">
                Limpiar
              </v-btn>
              <v-btn color="#FF4081" dark v-on:click="goBack()">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
export default {
  props: ["tokenData"],
  data() {
    return {
      validForm: true,
      respuestaText: "SI",
      encabezadoText: [],
      loaded: false,

      dateCollabsable: false,
      dateComponentConstraints: {},

      campoRequeridoRules: [(v) => !!v || "Campo requerido"],

      rulestextarea: [
        (v) => !!v || "Campo requerido",
        (v) => {
          if (v == null) {
            return true;
          } else {
            if (v.trim().length < 16) {
              return "Mínimo 16 Carácteres";
            } else if (v.trim().length > 600) {
              return "Máximo 500 Carácteres";
            } else return true;
          }
        },
      ],

      dynamicInputsErrorMessage: false,

      dynamicVModels: [],
      dynamicInputVmodels: [],

      extraDataItems: [],
      inputDinamicos: [],

      documentosTag: false,

      selectedDate: "",
      observacionesSelected: "",

      noMailsSelected: false,
      tempMails: [],
      datos: null
    };
  },
  async mounted() {
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.changeReporteMenuOption(this.datos.urlname);
    this.setMenuButtonSelected();
    this.getDatosGenerales();
    //this.testMethod();
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),
    setMenuButtonSelected() {
      let selectedOption = this.$route.name;
      //this.changeReporteMenuOption(selectedOption);
    },
    subelemento(valor, index) {
      var index2 = this.extraDataItems[index].opciones
        .map(function (e) {
          return e.valor;
        })
        .indexOf(valor);

      const exists =
        this.extraDataItems[index].opciones[index2].hasOwnProperty(
          "subelemento"
        );

      if (exists && this.extraDataItems[index].valorAnterior == 0) {
        let body = {
          textLabel:
            this.extraDataItems[index].opciones[index2].subelemento[0].idNombre,
          valor: null,
        };

        this.dynamicVModels.splice(index + 1, 0, body); //añade al vmodel de los elementos

        this.extraDataItems.splice(
          index + 1,
          0,
          this.extraDataItems[index].opciones[index2].subelemento[0]
        ); //añade en la posición siguiente al elemento que pertenece
      }
      if (exists && this.extraDataItems[index].valorAnterior != 0) {
        var index3 = this.extraDataItems[index].opciones
          .map(function (e) {
            return e.valor;
          })
          .indexOf(this.extraDataItems[index].valorAnterior);
        const exists3 =
          this.extraDataItems[index].opciones[index3].hasOwnProperty(
            "subelemento"
          );

        if (exists3) {
          //si es verdadero es que en el valor anterior si tenia un subelemento y se elimina el subelemento

          this.dynamicVModels.splice(index + 1, 1);
          this.extraDataItems.splice(index + 1, 1);
        }
        let body = {
          textLabel:
            this.extraDataItems[index].opciones[index2].subelemento[0].idNombre,
          valor: null,
        };

        //this.dynamicVModels.push(body);
        this.dynamicVModels.splice(index + 1, 0, body); //añade al vmodel de los elementos

        this.extraDataItems.splice(
          index + 1,
          0,
          this.extraDataItems[index].opciones[index2].subelemento[0]
        ); //añade en la posición siguiente al elemento que pertenece
        //this.extraDataItems.push(this.extraDataItems[index].opciones[index2].subelemento[0])
        //console.log(this.extraDataItems);
        // = tempArray;
      }
      if (!exists && this.extraDataItems[index].valorAnterior != 0) {
        var index3 = this.extraDataItems[index].opciones
          .map(function (e) {
            return e.valor;
          })
          .indexOf(this.extraDataItems[index].valorAnterior);
        const exists3 =
          this.extraDataItems[index].opciones[index3].hasOwnProperty(
            "subelemento"
          );

        if (exists3) {
          //si es verdadero es que en el valor anterior si tenia un subelemento y se elimina el subelemento
          this.dynamicVModels.splice(index + 1, 1);
          this.extraDataItems.splice(index + 1, 1);
        }
      }

      this.extraDataItems[index].valorAnterior = valor;
    },

    dynamicRulesGen(item) {
      var resultRules = [];
      try {
        if (item.required == "SI") {
          resultRules.push((v) => !!v || "Campo requerido");
        }
        if (item.regex != null) {
          if (item.idNombre != "tCorreoCopia") {
            resultRules.push(
              (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
            );
          }
        }
        const existsmaxlength = item.hasOwnProperty("maxlength");
        const existsminlength = item.hasOwnProperty("minlength");
        if (existsmaxlength && existsminlength) {
          resultRules.push((v) => {
            if (v == null) {
              return true;
            } else {
              if (v.trim().length < item.minlength) {
                return "Mínimo " + item.minlength + " Carácteres";
              } else if (v.trim().length > item.maxlength) {
                return "Máximo " + item.maxlength + " Carácteres";
              } else return true;
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
      return resultRules;
    },

    async getDatosGenerales() {
      let today = new Date().toJSON().slice(0, 10);
      this.selectedDate = today;

      let getTokenData = MetodosGenerales.getJsonTokenData(this.tokenData);
      console.log("el token data: ", getTokenData);

      if (getTokenData.claveMovimiento == 745) {
        this.documentosTag = true;
      }

      if (getTokenData.respuesta == 0) {
        this.respuestaText = "NO"; // SETUP RESPUESTA TEXT
      }
      let response = await reporteExpJur.ObtenerDatosGeneralesMovimiento(
        this.datos,
        getTokenData.claveMovimiento
      );

      this.encabezadoText = response.tipoMovimiento.encabezado; //SET UP ENCABEZADO INFO
      this.dateComponentConstraints = response.fecha;

      if (
        response.respuesta.opciones[
          this.respuestaText
        ].servicio.toLowerCase() != "sin servicio"
      ) {
        let especificosResponse =
          await reporteExpJur.ObtenerEspecificosMovimiento(
            this.datos,
            getTokenData.claveMovimiento,
            getTokenData.respuesta
          );

        this.inputDinamicos = especificosResponse.inputsDinamicos;

        if (this.inputDinamicos != undefined) {
          this.inputDinamicos.forEach((element) => {
            let body = {
              textLabel: element.txtlabel,
              idNombre: element.idNombre,
              docValor: element.valor,
            };
            if (element.tipoInput.toString().toLowerCase() == "checkbox") {
              body.valor = false;
            }

            this.dynamicInputVmodels.push(body);
          });
        }

        this.extraDataItems = especificosResponse.inputs;
        this.extraDataItems.forEach((element) => {
          let body = {
            textLabel: element.idNombre,
            valor: null,
          };
          if (element.tipoInput.toString().toLowerCase() == "mailtextfield") {
            body.searchIteam = "";
            body.items = [];
            body.selectedItems = [];
          }
          if (element.textarea != "") {
            body.valor = element.valor;
          }
          if (
            element.tipoInput.toString().toLowerCase() == "select" ||
            element.tipoInput.toString().toLowerCase() == "selectcorreos"
          ) {
            body.opciones = element.opciones;
          }

          this.dynamicVModels.push(body);
        });
      }

      this.loaded = true;
      this.dateCollabsable = true;
    },

    async newSelectedMails(value, listIndex) {
      //TODO: append here the mails with the petion of item.servicio
      let correosResponse = await reporteExpJur.obtenerCorreosPorZona(
        this,
        value
      );
      if (this.tempMails.length > 0) {
        this.dynamicVModels[listIndex].selectedItems = this.dynamicVModels[
          listIndex
        ].selectedItems.filter((item) => !this.tempMails.includes(item));
      }

      correosResponse.data.forEach((element) => {
        this.tempMails.push(element.correo);
        this.dynamicVModels[listIndex].selectedItems.push(element.correo);
      });
    },

    clearMailSearch(listIndex) { },

    resetItemsSelector(event, item, listIndex) {
      // this.dynamicVModels[listIndex].selectedItems =
      //   this.dynamicVModels[listIndex].valor;

      this.dynamicVModels[listIndex].selectedItems.push(
        this.dynamicVModels[listIndex].valor
      );

      this.dynamicVModels[listIndex].searchIteam = null;
      this.dynamicVModels[listIndex].items = null;
    },

    deleteFromList(index, item) {
      this.dynamicVModels[index].selectedItems = this.dynamicVModels[
        index
      ].selectedItems.filter((element) => element !== item);

      if (this.dynamicVModels[index].selectedItems.length == 0) {
        this.dynamicVModels[index].valor = null;
      }
    },

    addMailValider(event, item, listIndex) {
      //console.log("ESCRIBISTE.. EL EVENTO: ", event);
      //keyCode = 13,186

      // if (event.keyCode == 13 || event.keyCode == 186) {

      // }

      if (
        RegExp(item.regex).test(this.dynamicVModels[listIndex].searchIteam) ==
        true
      ) {
        this.dynamicVModels[listIndex].items = [
          {
            value: this.dynamicVModels[listIndex].searchIteam,
            text: this.dynamicVModels[listIndex].searchIteam,
          },
        ];
      }
    },

    goBack() {
      //TODO: Pop up message for user confirmation on cancel operation
      this.$router.go(-1);
    },

    clearOptions() {
      //TODO: define what a clear option will do: CLEAR EVERYTHING FROM date to below
      window.location.reload();
    },

    extraValidations() {
      let minimoUno = 0;
      if (this.dynamicInputVmodels.length == 0) {
        minimoUno++;
      } else {
        this.dynamicInputVmodels.forEach((element) => {
          if (element.valor == true) {
            minimoUno++;
          }
        });
      }

      if (minimoUno < 1) {
        this.dynamicInputsErrorMessage = true;
        return false;
      }
      this.dynamicInputsErrorMessage = false;
      return true;
    },

    async saveMovimientoProcess() {
      try {
        this.$swal({
          position: "center",
          title: "Cargando...",
          html: "Espere un momento por favor",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirm: false,
        });
        this.$swal.showLoading();

        this.$refs.form.validate();
        let extraValid = await this.extraValidations();
        let formValidation = this.$refs.form.validate();

        if (extraValid == false || formValidation == false) {
          this.$swal({
            position: "center",
            icon: "error",
            title: "Llene todos los campos correctamente",
            html: "Por favor llene o verifique que los datos sean correctos en los campos marcados",
            showConfirmButton: true,
          });
          return false;
        }

        let movimientoBody = {};
        let getTokenData = MetodosGenerales.getJsonTokenData(this.tokenData);
        let datosReporte = await MetodosGenerales.obtenerSessionReporte(
          "reporte"
        );

        movimientoBody.ClaveMovimiento = getTokenData.claveMovimiento;
        movimientoBody.Reporte = datosReporte.nrreporte;
        movimientoBody.Indice = datosReporte.svindice;

        movimientoBody.dFechaMov = this.selectedDate;
        movimientoBody.sRespMov = this.respuestaText;
        movimientoBody.txtObsMov = this.observacionesSelected;

        this.dynamicVModels.forEach((element) => {
          if (
            element.selectedItems != undefined &&
            element.selectedItems != null
          ) {
            //console.log("entre a selectedItems");
            movimientoBody[element.textLabel] =
              element.selectedItems.toString();
          }

          if (element.valor != undefined || element.valor != null) {
            movimientoBody[element.textLabel] = element.valor;
          }
        });

        let tempDocObject = [];
        this.dynamicInputVmodels.forEach((element) => {
          if (element.idNombre == "chDocumentos") {
            if (element.valor == true) {
              tempDocObject.push(element.docValor);
            }
          }
        });
        movimientoBody.chDocumentos = tempDocObject.toString();
        let formattedMovimientoBody = [];
        formattedMovimientoBody.push(movimientoBody);
        let movimientoResponse = await reporteExpJur.guardarMovimiento(
          this,
          JSON.stringify(formattedMovimientoBody)
        );

        this.$swal({
          position: "center",
          icon: "success",
          title: "Exito!",
          html: movimientoResponse.mensaje,
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          this.$router.go(-1);
        });
      } catch (e) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Algo salio mal",
          html: "Algo salio mal, por favor intente de nuevo mas tarde",
          showConfirmButton: true,
        });
      }
    },
  },
  watch: {
    selectedDate(newDate, oldDate) {
      //Cierra el collapsable al escojer otra fecha.
      if (this.dateCollabsable == true) {
        document.getElementById("datePickerCollapse").click();
      }
    },
  },
};
</script>
<style>
.addMovimientoClassList .vs-collapse-item--header {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  background-color: #e0e0e0 !important;
}

.addMovimientoClassList .con-content--item {
  padding: 0px !important;
}
</style>
<style scoped>
.card-title-style {
  background-color: #536dfe;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1.1em;
  color: white;
}

.title-card-style {
  padding: 1.5px !important;
  max-height: auto;
}

.collapsable-container {
  background-color: white;
  height: 100% !important;
}

.type-label-style {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 12px;
}

.type-text-style {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 1.3em;
}

.date-card-title-text {
  margin-top: 1px !important;
  margin-bottom: 1px !important;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: rgb(59, 59, 59);
}

.calendar-container-style {
  padding: 0px !important;
}

.document-chekboxes-style {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 12px;
}

.error-message-style {
  font-family: "Roboto", sans-serif;
  color: red;
  font-weight: 400;
  font-size: 12px;
}
</style>
